import { COLORS } from 'helpers/globals'
import { row, column, column33, column40, column50 } from 'helpers/styles/grid'

const label = {
  lineHeight: '3.5rem',
  ...column,
  padding: '0 !important',
  marginRight: '0 !important',
  color: 'black'
}

export default {
  container: row,
  label,
  normalLabel: {
    ...label,
    ...column33
  },
  wideLabel: {
    ...label,
    ...column40
  },
  extraWideLabel: {
    ...label,
    ...column50
  },
  inputWrapper: {
    ...column,
    position: 'relative',
    padding: '0 !important',
    '& select': {
      paddingRight: 0
    }
  },
  caretDown: {
    fontSize: '1.5rem',
    color: COLORS.secondary,
    position: 'absolute',
    pointerEvents: 'none',
    top: '.8rem',
    right: '.8rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/CalculatorSelect/style.js